//@ts-check

/**
 * Get all descendant elements.
 * @param {import('./reducers/contentReducer/types').DasElementLike} element
 * @return {Array<import('./reducers/contentReducer/types').DasElementLike>}
 */
export var getDescendants = function getDescendants(element) {
  var collectDescendants = function collectDescendants(element, accumulator) {
    element.elements.forEach(function (currentElement) {
      if (currentElement.elementName === 'elementSequence') accumulator.push(currentElement);
      collectDescendants(currentElement, accumulator);
    });
    return accumulator;
  };

  var result = [];
  return collectDescendants(element, result);
};
/**
 * Get descendant element by id.
 * @param {import('./reducers/contentReducer/types').DasElementLike} element
 * @param  {string} id
 * @return {import('./reducers/contentReducer/types').DasElementLike}
 */

export var getDescendant = function getDescendant(element, id) {
  return getDescendants(element).find(function (descendant) {
    return descendant.id === id;
  });
};
/**
 * Get parent element by child id.
 * @param {import('./reducers/contentReducer/types').DasElementLike} startingElement starting element to start the search
 * @param  {string} id The child element id
 * @return {import('./reducers/contentReducer/types').DasElementLike}
 */

export var getParent = function getParent(startingElement, id) {
  var result = null;

  for (var index = 0; index < startingElement.elements.length; index++) {
    if (startingElement.elements[index].id === id) return startingElement;
    result = getParent(startingElement.elements[index], id);
    if (result !== null) return result;
  }

  return result;
};
/**
 * Get descendant element by id.
 * @param {import('./reducers/contentReducer/types').DasJob} job
 * @param  {string} elementId Output element id
 */

export var removeParentRelationship = function removeParentRelationship(job, elementId) {
  var element = getDescendant(job.output.element, elementId);
  if (!element) throw new Error('Could not find element.');
  var elementDataSource = job.dataSources.find(function (dataSource) {
    return dataSource.id === element.dataSource;
  });

  if (elementDataSource.elementName === 'equalFilterFunction') {
    removeDataSource(job, elementDataSource.id); // use data source directly

    element.dataSource = elementDataSource.dataSource; // move element to root

    removeElement(job.output.element, element.id);
    job.output.element.elements.push(element);
  }
};
/**
 * Get datasource by id.
 * @param {import('./reducers/contentReducer/types').DasJob} job
 * @param  {string} id Data source id
 */

export var getDataSource = function getDataSource(job, id) {
  return job.dataSources.find(function (dataSource) {
    return dataSource.id === id;
  });
};
/**
 * Remove datasource by id.
 * @param {import('./reducers/contentReducer/types').DasJob} job
 * @param  {string} id Data source id
 */

export var removeDataSource = function removeDataSource(job, id) {
  var index = job.dataSources.findIndex(function (dataSource) {
    return dataSource.id === id;
  });
  if (index !== -1) job.dataSources.splice(index, 1);
  var diagramIndex = job.diagram.items.findIndex(function (diagram) {
    return diagram.id === id;
  });
  if (diagramIndex !== -1) job.diagram.items.splice(diagramIndex, 1);
};
/**
 * Remove element by id.
 * @param {import('./reducers/contentReducer/types').DasElementLike} rootElement
 * @param  {string} id Element id to be removed
 */

export var removeElement = function removeElement(rootElement, id) {
  var parent = getParent(rootElement, id); // element not found

  if (!parent) return;
  var index = parent.elements.findIndex(function (element) {
    return element.id === id;
  });
  parent.elements.splice(index, 1);
};
/**
 * Returns the initial data source resolving through filters
 * @param {import('./reducers/contentReducer/types').DasJob} job
 * @param  {import('./reducers/contentReducer/types').DasElementSequence} outputElement Output element
 */

export var getInitialDataSource = function getInitialDataSource(job, outputElement) {
  var dataSource = getDataSource(job, outputElement.dataSource);
  if (!dataSource) return {};

  if (dataSource && dataSource.elementName === 'equalFilterFunction') {
    dataSource = getDataSource(job, dataSource.dataSource);
  }

  return dataSource;
};